import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-clm-com-accessories',
    imports: [FormsModule, MatIcon],
    templateUrl: './clm-com-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-com-accessories.component.css'
})
export class ClmComAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  ballValveSelection!: GuruEntity;
  electricHeaterSelection!: GuruEntity;
  filterBracketsSelection!: GuruEntity;
  filterFrameSelection!: GuruEntity;
  hoseKitsSelection!: GuruEntity;
  hoseKitsWithAutoflowSelection!: GuruEntity;
  replacementFiltersSelection!: GuruEntity;
  thermostatSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  drainPanSelection!: GuruEntity;
  waterValveSelection!: GuruEntity;
  flowRateSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.ballValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBallValveConn');
    this.electricHeaterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USElecHtKw');
    this.filterBracketsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilterBracket');
    this.filterFrameSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilterFrame');
    this.hoseKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKit');
    this.hoseKitsWithAutoflowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKitAutoFlow');
    this.replacementFiltersSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilter');
    this.thermostatSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlACC');
    this.drainPanSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.waterValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterValve');
    this.flowRateSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFlowrate');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
